import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from 'antd';
import UIComponent from './uiComponent';
function UIButtonComponent(props) {
    return (_jsx(Button, { type: props.type, style: { marginRight: '10px', marginBottom: '20px', marginTop: '20px', ...props.styling }, onClick: props.onClick, disabled: props.disabled, children: props.title }));
}
export default class UIButton extends UIComponent {
    title;
    type;
    style;
    disabled;
    onClick;
    constructor(s) {
        super(s);
        this.title = this.getProperty('title');
        this.style = this.getProperty('style', '');
        this.type = this.getProperty('type', 'primary');
    }
    getComponent() {
        const props = {
            title: this.title,
            type: this.type,
            disabled: this.disabled,
            styling: this.style,
            onClick: () => {
                this.onClick();
            },
        };
        return _jsx(UIButtonComponent, { ...props }, this.name);
    }
}
//# sourceMappingURL=uiButton.js.map